<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">INCIDENCIAS REGISTRADAS</h5>

      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-bordered">
          <thead>
          <tr>
            <td>
              <button
                  class="btn btn-success"
                  type="button"
                  @click="crearReporte()"
              >
                Reportar Incidencia
                <i class="fa fa-plus"></i>
              </button>
            </td>
            <td colspan="5"></td>
          </tr>
          <tr>
          <th>
            <select
                class="custom-select"

                v-model="seleccionado"

                @change="getConfigEmpresa()"
            >
              <option value="">SELECCIONAR EMPRESA</option>
              <option
                  v-for="(t, i) in vempresas"
                  :value="t.id_empresa"
                  :key="t.nombre_empresa + i"
              >{{ t.nombre_empresa}}</option
              >
            </select>
           <!-- <v-select placeholder="Seleccione Centro de Reclusion"  label="pen_nombre" :options="vempresas"  @input="onChangeCentro"></v-select>-->
          </th>
            <th>
              <select
                  class="custom-select"
                  v-model="vueloselec"
              >
                <option value="">SELECCIONAR VUELO</option>
                <option
                    v-for="(t, i) in confempresa"
                    :value="t.id_config_empresa"
                    :key="i"
                    @input="onChange"
                >{{ t.nro_vuelo}}</option
                >
              </select>
              <!--<v-select placeholder="Seleccione Nacionalidad"  label="nombre" :options="confempresa"  @input="onChange"></v-select>-->
            </th>
            <th>
              <b-form-datepicker
                  id="fecha-inicial"
                  placeholder="Seleccione fecha inicio"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  v-model="fecha_ini"
                  @input="fechaInicial"
                  class="mb-2"
                  locale="es"></b-form-datepicker>
            </th>
            <th>
              <b-form-datepicker
                  id="fecha-final"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  placeholder="Seleccione fecha fin"
                  v-model="fecha_fin"
                  @input="fechaFinal"
                  class="mb-2"
                  locale="es">
              </b-form-datepicker>
            </th>
          </tr>
          <tr class="text-center">
            <th>
              <small class="font-weight-bold">FRONTERA</small>
            </th>
            <th><small class="font-weight-bold">FECHA</small></th>
            <th><small class="font-weight-bold">OBSERVACION</small></th>
            <th><small class="font-weight-bold">VER DETALLE</small></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in incidenciasgen" :key="index">
            <td>
              <small>{{ item.cod_frontera }}</small>
            </td>
            <td class="text-center">
              <small> {{ new moment(item.fecha_reg).format("DD-MM-YYYY HH:MM:SS") }}</small>
            </td>
            <td class="text-center">
              {{item.observacion}}
            </td>
            <td class="text-center">
              <button
                  class="btn btn-success"
                  type="button"
                  @click="obtenerIncidenciasDetalle(item.idincidencias_gen)"
              ><i class="fa fa-bars"> Ver</i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        </div>
    </div>
    </div>
    <Loading v-show="cargando" />
    <b-modal
        class="modal fade"
        title="Observaciones"
        size="xl"
        hide-footer
        ref="modalObservacion"
        :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-bordered table-condensed">

              <thead>

              <tr class="text-center">
                <th><small class="font-weight-bold">NOMBRE FRONTERA</small></th>
                <th><small class="font-weight-bold">EQUIPO</small></th>
                <th><small class="font-weight-bold">ERROR</small></th>
                <th><small class="font-weight-bold">EN CASO DE OTRO</small></th>
                <th><small class="font-weight-bold">ESTADO</small></th>
                <th><small class="font-weight-bold">COMENTARIO SOPORTE</small></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in incidenciasdet" :key="index">
                <td>
                  <small>{{ item.cod_frontera }}</small>
                </td>
                <td class="text-center">
                  <small> {{ item.equipo }}</small>
                </td>
                <td class="text-center">
                  {{item.nombre}}
                </td>
                <td class="text-center">
                  {{item.observacion_equipo}}
                </td>
                <td class="text-center">
                  {{(item.estado_registro == 1 )?'REPORTADO':'SOLUCIONADO'}}
                </td>
                <td class="text-center">
                  {{item.solucion_soporte}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
//import { required } from "vuelidate/lib/validators";
export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      seleccionado:'',
      seleccionadoerr1:'',
      seleccionadoerr2:'',
      seleccionadoerr3:'',
      seleccionadoerr4:'',
      seleccionadoerr5:'',
      vueloselec:'',
      fields:[],
      vempresas:[],
      confempresa:[],
      dataenv:{},
      perPage: 3,
      currentPage: 1,

      parametro: '',
      incidenciasgenNew:[],
      incidenciasgen:[],
      incidenciasdet:[],
      observacion : {
        descripcion:'',
        vuelo:'',
        fecha:'28/01/16'
      },
      observaciones:[],
      cargando: false,
      erroresUno:[],
      erroresDos:[],
      erroresTres:[],
      erroresCuatro:[],
      erroresCinco:[],
      fecha_ini:null,
      fecha_fin: null
    };
  },
  methods: {

    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/get_Empresa_Vuelo`);
        this.vempresas = resultados.data.contenido;
      //  console.log(this.vempresas);
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa() {
      this.cargando = true;
      try {
        this.cargando = false;
        let resultados = await this.axios.get(`/getConfig_empresa/${this.seleccionado}`);
        this.confempresa = resultados.data.contenido;
       // console.log(this.confempresa);
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async obtenerIncidenciasGen(){
      let id_config_flujo=null;
    try {
      ///${id_config_flujo}/${fecha_ini}/${fecha_fin}
      let resultados = await this.axios.get(`/incidencias-gen/${id_config_flujo}/${this.fecha_ini}/${this.fecha_fin}`);
      this.incidenciasgenNew= resultados.data.contenido;
      this.fields = ['FRONTERA', 'FECHA',  'OBSERVACION','VER DETALLE'];
      this.incidenciasgen = this.incidenciasgenNew // this.incidenciasgen.map((e) => {return {... e, fecha_reg: new moment(e.fecha_reg).format("YYYY-MM-DD") }})
     // this.incidenciasgen = this.incidenciasgen.map((e)=>{return {fontera:e.cod_frontera, fecha: moment(e.fecha_reg).format("DD-MM-YYYY HH:MM:SS") }})
    //  console.log(this.incidenciasgen);
    } catch (error){
      console.log("catch: ", error);
    }
    },

    async obtenerIncidenciasDetalle(id){
      this.$refs["modalObservacion"].show();
      try {
        let resultados = await this.axios.get(`/incidencias-det/${id}`);
        this.incidenciasdet= resultados.data.contenido;
      // console.log(this.incidenciasdet);
      } catch (error){
        console.log("catch: ", error);
      }
    },
    async obtenerErrores(){
      let resultados = await this.axios.get(`/errores`);
      this.erroresUno= resultados.data.contenido;
    },
    onChangeCentro(){

    },
    onChange(){

    },
    async fechaInicial(value){
      this.fecha_ini = value

      this.obtenerIncidenciasGen()
    },
    async fechaFinal(value){
      this.fecha_fin = value
      this.obtenerIncidenciasGen()
    },

    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    seleccionarError(item){
      item.observacion_equipo = "";
    },
    crearReporte(){
      this.$router.push('crearReporte');
    }
  },
  created() {
        this.obtenerErrores(),
        this.getNombreEmpresas(),
        this.obtenerIncidenciasGen()


  },

};
</script>
